var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext, useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined';
import { Avatar, Box, CardMedia, Popover, Tooltip, Typography, UserFilledIcon, } from '@kareo/design-system';
import patientData from 'shared-assets/lib/patient';
import rollbar from 'shared-assets/src/errors/errors';
import OverviewLinks from 'shared-assets/facesheet-ui/components/Facesheet/Header/OverviewLinks';
import PatientCard from 'shared-assets/facesheet-ui/components/Facesheet/Header/PatientCard';
import { formatISODateShort, formatPatientAddress, formatPatientBalance, formatPatientInsurance, formatPatientName, getAgeView, } from 'shared-assets/facesheet-ui/utils/patientHelper';
import { PatientContext } from 'shared-assets/facesheet-ui/components/Facesheet/Container/Facesheet';
import PatientPhotoUpload from 'shared-assets/facesheet-ui/components/Facesheet/Header/PhotoUpload/PatientPhotoUpload';
import { getPatientAvatar } from 'shared-assets/facesheet-ui/service/patient/service';
import GeneralError from 'shared-assets/facesheet-ui/components/Facesheet/Error/GeneralError';
import { formatRawPhoneNumber } from 'shared-assets/lib/utils/phoneNumber';
var PatientOverview = function (_a) {
    var patientId = _a.patientId, reloadPatient = _a.reloadPatient;
    var patient = useContext(PatientContext);
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = useState('Unavailable'), balance = _c[0], setBalance = _c[1];
    var _d = useState(''), alertMessage = _d[0], setAlertMessage = _d[1];
    var _e = useState(''), address = _e[0], setAddress = _e[1];
    var _f = useState(false), isPhotoIconDisplayed = _f[0], setIsPhotoIconDisplayed = _f[1];
    var _g = useState(false), isPhotoModalOpen = _g[0], setIsPhotoModalOpen = _g[1];
    var _h = useState(false), hasPatientPhoto = _h[0], setHasPatientPhoto = _h[1];
    var _j = useState(''), photoUrl = _j[0], setPhotoUrl = _j[1];
    var _k = useState(null), nextApptInfo = _k[0], setNextApptInfo = _k[1];
    var _l = useState(null), lastApptInfo = _l[0], setLastApptInfo = _l[1];
    var _m = useState(true), loadingApptInfo = _m[0], setLoadingApptInfo = _m[1];
    var _o = useState(''), cacheDate = _o[0], setCacheDate = _o[1];
    var _p = useState(false), lastApptInfoError = _p[0], setLastApptInfoError = _p[1];
    var getAvatarPhoto = function (patientId) {
        getPatientAvatar(patientId)
            .then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
            var imageBytes, blob, imageUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(res.status === 200)) return [3 /*break*/, 2];
                        return [4 /*yield*/, res.arrayBuffer()];
                    case 1:
                        imageBytes = _a.sent();
                        blob = new Blob([imageBytes], { type: 'image/jpeg' });
                        imageUrl = URL.createObjectURL(blob);
                        setPhotoUrl(imageUrl);
                        setHasPatientPhoto(true);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); })
            .catch(function (error) { return rollbar.error(error); });
    };
    useEffect(function () {
        if (patient && patient.patientId > 0) {
            if (!!patient.address1) {
                setAddress(formatPatientAddress(patient));
            }
            if (!!patient.alertMessage) {
                setAlertMessage(patient.alertMessage);
            }
            patientData
                .getBalance(patient.guid, true)
                .then(function (patientBalance) {
                setBalance(formatPatientBalance(patientBalance.remainingPatientAmount));
            })
                .catch(function (error) { return rollbar.error(error); });
            getAvatarPhoto(patientId);
        }
    }, [patient, patientId]);
    var handlePopoverOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handlePopoverClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var toggleAvatarPhotoIcon = function (isDisplayed) {
        setIsPhotoIconDisplayed(isDisplayed);
    };
    var handleModalOpen = function () {
        toggleAvatarPhotoIcon(false);
        setIsPhotoModalOpen(true);
    };
    var handleModalClose = function () {
        setIsPhotoModalOpen(false);
    };
    var reloadPatientPhoto = function () {
        getAvatarPhoto(patientId);
    };
    var truncateString = function (str, num) {
        if (str.length > num) {
            return str.slice(0, num) + '...';
        }
        else {
            return str;
        }
    };
    var formatPatientOverviewInfo = function () {
        if (patient != null) {
            var gender = "" + patient.gender;
            var dob = formatISODateShort(patient.dob) + " (" + getAgeView(patient.ageInYears, patient.monthsSinceBirthday) + ")";
            var phoneNumber = "" + formatRawPhoneNumber(patient.phoneNumber);
            var insurance = formatPatientInsurance(patient);
            var overviewInfo = [gender, dob, phoneNumber]
                .filter(Boolean)
                .join(' | ');
            return (React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: "body1", component: "div", display: "inline" }, overviewInfo),
                insurance.length > 0 && (React.createElement(Typography, { variant: "body1", component: "div", display: "inline" },
                    React.createElement(Tooltip, { title: insurance.length > 55 ? insurance : '', placement: "top-end" },
                        React.createElement("span", null, " | " + truncateString(insurance, 55)))))));
        }
        return '';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { display: "flex" },
            React.createElement(Grid, { container: true, spacing: 1, wrap: "nowrap" },
                React.createElement(Grid, { item: true },
                    React.createElement(Avatar, { size: "md", disableElevation: true, 
                        // @ts-ignore
                        onMouseEnter: function () { return toggleAvatarPhotoIcon(true); }, onMouseLeave: function () { return toggleAvatarPhotoIcon(false); }, onClick: handleModalOpen, style: { cursor: 'pointer', position: 'relative' } },
                        photoUrl ? (React.createElement(CardMedia, { component: "img", src: photoUrl })) : (React.createElement(UserFilledIcon, { fontSize: "large" })),
                        isPhotoIconDisplayed && (React.createElement(CameraAltOutlinedIcon, { color: "primary", fontSize: "large", style: { position: 'absolute' } })))),
                patient ? (React.createElement(Grid, { item: true, xs: 12, sm: true, container: true },
                    React.createElement(Grid, { item: true, container: true, direction: "column" },
                        React.createElement(Grid, { item: true },
                            React.createElement(Typography, { variant: "h2", style: { marginBottom: 0, width: 'fit-content' }, "aria-owns": "mouse-over-popover", "aria-haspopup": "true", onMouseEnter: function (event) {
                                    handlePopoverOpen(event);
                                } }, patient && formatPatientName(patient))),
                        React.createElement(Grid, { item: true },
                            React.createElement(Typography, { component: "div" }, patient && formatPatientOverviewInfo())),
                        React.createElement(Grid, { item: true }, patient && (React.createElement(OverviewLinks, { patient: patient, balance: balance, alert: alertMessage })))))) : (React.createElement(Grid, { item: true },
                    React.createElement(GeneralError, { reloadData: reloadPatient }))))),
        React.createElement(Popover, { id: "mouse-over-popover", open: open, anchorEl: anchorEl, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, onClose: handlePopoverClose, PaperProps: { onMouseLeave: handlePopoverClose } }, patient && (React.createElement(PatientCard, { patient: patient, apptInfoFunctions: {
                setLastApptInfo: setLastApptInfo,
                setNextApptInfo: setNextApptInfo,
                setLoadingApptInfo: setLoadingApptInfo,
                setCacheDate: setCacheDate,
                setLastApptInfoError: setLastApptInfoError,
            }, nextApptInfo: nextApptInfo, lastApptInfo: lastApptInfo, loadingApptInfo: loadingApptInfo, alert: patient.alertMessage, insurance: formatPatientInsurance(patient), address: address, patientImgSrc: photoUrl, cacheDate: cacheDate, lastApptInfoError: lastApptInfoError }))),
        isPhotoModalOpen && (React.createElement(PatientPhotoUpload, { patientId: patientId, isPhotoModalOpen: isPhotoModalOpen, closePhotoModal: handleModalClose, hasPatientPhoto: hasPatientPhoto, reloadPatientPhoto: reloadPatientPhoto }))));
};
export default PatientOverview;
